import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  get pageNavNext() {
    return this.element.querySelector('#page-nav .next a');
  }

  connect() {
    const week7Submit = document.querySelector(".week7-submit");

    if (week7Submit) {
      document.querySelectorAll(".mdc-radio").forEach((radio) => {
        const radioInput = radio.querySelector("input");
        radioInput.addEventListener("change", () => {
          week7Submit.removeAttribute("disabled");
        });
      });
      week7Submit.addEventListener("click", () => {
        document.querySelectorAll(".mdc-radio").forEach((radio) => {
          const radioInput = radio.querySelector("input");
          const radioContainer = radio.closest(".week7-radio");

          if (radioInput.checked) {
            const indicator = radioContainer.querySelector(".indicator");
            indicator.style.display = "table-cell";
            if (radioContainer.classList.contains("correct")) {
              this.enableNextNavigation();
            }
            radioContainer.querySelector(".week7-feedback").style.display =
              "table-cell";
          }
        });
      });
    }
  }

  enableNextNavigation() {
    this.pageNavNext.removeAttribute('disabled');
  }
}
